import attendancePolicy from  './policy/attendacePolicySlice';
import weekOffMasterReducer from "./master/weekOffMasterSlice";
import clockReducer from './attendanceRegularization/clockSlice'
import attendanceReducer from './attendanceRegularization/attendanceSlice';

const attendanceReducers = {
    attendancePolicy:attendancePolicy,
        weekOffMaster:weekOffMasterReducer,
        clock: clockReducer,
        attendance: attendanceReducer,

};

export default attendanceReducers;
